import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual, isNil, isArray } from 'lodash';
import { Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import Square from './Square';
import { updateCondition } from '../../data/experimentalDesign/conditionActions';
import {
  openConditionOccurrenceStack,
  openDeleteConditionModal
} from '../../data/experimentalDesign/modalActions';

class Condition extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nameEdit: false,
      participantsEdit: false,
      condition: props.condition,
      conditionHasChanged: false
    };

    this.handleParticipantsChange = this.handleParticipantsChange.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.toggleParticipantsEdit = this.toggleParticipantsEdit.bind(this);
    this.toggleNameEdit = this.toggleNameEdit.bind(this);
    this.saveParticipantsChange = this.saveParticipantsChange.bind(this);
    this.saveNameChange = this.saveNameChange.bind(this);
    this.conditionOccurrenceDragHandler = this.conditionOccurrenceDragHandler.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      condition: prevState.conditionHasChanged ? prevState.condition : nextProps.condition
    };
  }

  /**
   * Handles the onDrag event of a single occurrence, when dragged FROM a condition
   * @param event
   * @param fromConditionIndex
   * @param fromOccurrenceRow
   * @param fromOccurrenceIndex
   */
  conditionOccurrenceDragHandler(
    event,
    occurrence,
    fromConditionIndex,
    fromOccurrenceRow,
    fromOccurrenceIndex
  ) {
    event.dataTransfer.effectAllowed = 'move';
    const type = isArray(occurrence) ? occurrence[0].type : occurrence.type;
    event.dataTransfer.setData('isNew', false);
    event.dataTransfer.setData(`type/${type}`, true);
    event.dataTransfer.setData('fromConditionIndex', fromConditionIndex);
    event.dataTransfer.setData('fromOccurrenceRow', fromOccurrenceRow);
    event.dataTransfer.setData('fromOccurrenceIndex', fromOccurrenceIndex);

    // call de l'api ?
  }

  /**
   * Toggles edition mode of the participants for this condition
   */
  toggleParticipantsEdit() {
    this.setState({
      participantsEdit: !this.state.participantsEdit,
      conditionHasChanged: false
    });
  }

  /**
   * Toggles edition mode of the name for this condition
   */
  toggleNameEdit() {
    this.setState({
      nameEdit: !this.state.nameEdit,
      conditionHasChanged: false
    });
  }

  /**
   * Handles the change of value for the conditions number of participants
   * @param event
   * @param data
   */
  handleParticipantsChange(event, data) {
    this.setState({
      condition: { ...this.state.condition, nbr_participations: data.value },
      conditionHasChanged: !isEqual(data.value, this.state.condition.nbr_participations)
    });
  }

  /**
   * Handles the change of value for the condition's name
   * @param event
   * @param data
   */
  handleNameChange(event, data) {
    this.setState({
      condition: { ...this.state.condition, name: data.value },
      conditionHasChanged: !isEqual(data.value, this.state.condition.name)
    });
  }

  /**
   * Saves on the parent Container the project with new participants value
   */
  saveParticipantsChange() {
    if (this.state.conditionHasChanged) {
      this.props.dispatch(
        updateCondition(this.state.condition, () => {
          this.toggleParticipantsEdit();
        })
      );
    } else {
      this.toggleParticipantsEdit();
    }
  }

  /**
   * Saves on the parent Container the project with new name value
   */
  saveNameChange() {
    if (this.state.conditionHasChanged) {
      this.props.dispatch(
        updateCondition(this.state.condition, () => {
          this.toggleNameEdit();
        })
      );
    } else {
      this.toggleNameEdit();
    }
  }

  render() {
    const [occurrencesRow1, occurrencesRow2] = this.props.condition.occurrences.map(
      (occurrenceRow, occurrenceRowIndex) => {
        return occurrenceRow.map((e, occurrenceIndex) => {
          const args = [this.props.index, occurrenceRowIndex, occurrenceIndex];

          return isNil(e) ? (
            <Square
              key={occurrenceIndex}
              animateOnHover
              dropHandler={event => this.props.occurrenceDropHandler(event, ...args)}
            />
          ) : (
            <Square
              key={occurrenceIndex}
              editable={false}
              draggable
              occurrence={e}
              animateOnHover
              dragHandler={event => this.conditionOccurrenceDragHandler(event, e, ...args)}
              dropHandler={event => this.props.occurrenceDropHandler(event, ...args)}
              dragEndHandler={event => this.props.occurrenceDragEndHandler(event, ...args)}
              onClickHandler={event => this.props.dispatch(openConditionOccurrenceStack(...args))}
            />
          );
        });
      }
    );

    return (
      <div>
        <div className="grid-pair grid-pair--condition">
          <div className="grid-dashboard-condition">
            <div style={{ marginBottom: '10px' }}>
              {this.state.nameEdit ? (
                <Form.Input
                  autoFocus
                  className="participants"
                  type="text"
                  value={this.state.condition.name}
                  onChange={this.handleNameChange}
                  onBlur={this.saveNameChange}
                />
              ) : (
                <div className="grid-dashboard-condition__delete-container">
                  <span className="grid-dashboard-condition__name" onClick={this.toggleNameEdit}>
                    {this.state.condition.name}
                  </span>
                  <span
                    className="grid-dashboard-condition__delete"
                    onClick={e =>
                      this.props.dispatch(
                        openDeleteConditionModal(parseInt(this.props.condition.id, 10))
                      )
                    }
                  />
                </div>
              )}
            </div>

            <div className="grid-dashboard-condition__wrapper">
              <div className="grid-dashboard-condition__participants">
                {this.state.participantsEdit ? (
                  <Form.Input
                    autoFocus
                    className="grid-dashboard-condition__nbr grid-dashboard-condition__nbr--input"
                    type="number"
                    value={this.state.condition.nbr_participations}
                    onChange={this.handleParticipantsChange}
                    onBlur={this.saveParticipantsChange}
                  />
                ) : (
                  <span
                    className="grid-dashboard-condition__nbr grid-dashboard-condition__nbr--flat"
                    onClick={this.toggleParticipantsEdit}
                  >
                    {this.state.condition.nbr_participations}
                  </span>
                )}
              </div>

              <div className="grid-dashboard-condition__block">
                <div className="grid-dashboard">
                  <div className="grid-dashboard__wrapper">
                    <div className="square-list">{occurrencesRow1}</div>
                    <div className="square-list">{occurrencesRow2}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Square.propTypes = {
  occurrenceDropHandler: PropTypes.func,
  occurrenceDragEndHandler: PropTypes.func,
  participantsSaveHandler: PropTypes.func,
  nameSaveHandler: PropTypes.func,
  index: PropTypes.number
};

Square.defaultProps = {
  occurrenceDropHandler: () => {},
  occurrenceDragEndHandler: () => {},
  participantsSaveHandler: () => {},
  nameSaveHandler: () => {}
};

export default connect()(Condition);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/experimentalDesign/Condition.js